/**
 * CategoryListing Page - Modified to show Level 2 categories
 * Shows categories like "Machinery" instead of their children like "Loader"
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { 
  Package, 
  ChevronRight, 
  Grid, 
  List, 
  Search,
  Home,
  Loader
} from 'lucide-react';
import { buildHierarchy } from '../utils/buildHierarchy';
import { debugLog } from '../constants/config';
import { fetchTaxonomyTerms } from '../services/api';

const WP_API_BASE = process.env.REACT_APP_WP_BASE || 'https://goldensparrowuae.com/wordpress/wp-json';

// export default function CategoryListing() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
  
//   // State management
//   const [taxonomy, setTaxonomy] = useState('equipment-buy');
//   const [categories, setCategories] = useState([]);
//   const [level2Categories, setLevel2Categories] = useState([]); // Store only level 2 categories
//   const [filteredCategories, setFilteredCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

//   // Initialize taxonomy from URL
//   useEffect(() => {
//     const taxonomyFromUrl = searchParams.get('taxonomy') || 'equipment-buy';
//     setTaxonomy(taxonomyFromUrl);
//   }, [searchParams]);

//   // Fetch categories when taxonomy changes
//   useEffect(() => {
//     fetchCategories();
//   }, [taxonomy]);

//   // Filter level 2 categories based on search term
//   useEffect(() => {
//     let filtered = level2Categories;

//     // Filter by search term
//     if (searchTerm) {
//       const searchLower = searchTerm.toLowerCase();
//       filtered = filtered.filter(category => 
//         category.name.toLowerCase().includes(searchLower) ||
//         category.description?.toLowerCase().includes(searchLower)
//       );
//     }

//     setFilteredCategories(filtered);
//   }, [level2Categories, searchTerm]);

//   /**
//    * Extract Level 2 categories from the hierarchy
//    * This function traverses the category tree and collects only level 2 categories
//    */
//   const extractLevel2Categories = (categories, level = 1, parentInfo = null) => {
//     let level2Cats = [];
    
//     categories.forEach(category => {
//       // Create an enhanced category object with parent information and child count
//       const enhancedCategory = {
//         ...category,
//         level: level,
//         parentInfo: parentInfo,
//         childCount: category.children ? category.children.length : 0
//       };

//       if (level === 2) {
//         // This is a level 2 category (the ones we want to display)
//         level2Cats.push(enhancedCategory);
//       } else if (level === 1 && category.children && category.children.length > 0) {
//         // Continue traversing from level 1 to get to level 2
//         const parentData = {
//           id: category.id,
//           name: category.name,
//           slug: category.slug,
//           level: level
//         };
//         level2Cats = [...level2Cats, ...extractLevel2Categories(category.children, level + 1, parentData)];
//       }
//     });
    
//     return level2Cats;
//   };

//   const fetchCategories = async () => {
//     setLoading(true);
//     setError(null);
    
//     try {
//       // Try the custom API first for better image support
//       try {
//         const response = await fetchTaxonomyTerms(taxonomy);
//         if (response && response.terms) {
//           const hierarchy = buildHierarchy(response.terms);
          
//           setCategories(hierarchy);
          
//           // Extract only level 2 categories (like "Machinery")
//           const extractedLevel2 = extractLevel2Categories(hierarchy);
//           setLevel2Categories(extractedLevel2);
          
//           debugLog('Full hierarchy:', hierarchy);
//           debugLog('Extracted Level 2 categories:', extractedLevel2);
//           return;
//         }
//       } catch (apiError) {
//         debugLog('Custom API failed, falling back to WordPress API:', apiError);
//       }

//       // Fallback to WordPress API
//       const endpoint = taxonomy === 'equipment-buy' ? 'equipment-buy' : 'equipment-rent';
//       const response = await fetch(`${WP_API_BASE}/wp/v2/${endpoint}?per_page=100&_embed`);
      
//       if (!response.ok) {
//         throw new Error(`Failed to fetch ${taxonomy} categories`);
//       }
      
//       const data = await response.json();
      
//       // Enhance data with image information from _embedded
//       const enhancedData = data.map(term => {
//         let featured_image = null;
        
//         // Try to get featured image from different sources
//         if (term._embedded && term._embedded['wp:featuredmedia'] && term._embedded['wp:featuredmedia'][0]) {
//           const media = term._embedded['wp:featuredmedia'][0];
//           featured_image = {
//             id: media.id,
//             url: media.source_url,
//             alt: media.alt_text || term.name,
//             sizes: media.media_details?.sizes || {}
//           };
//         }
        
//         return {
//           ...term,
//           featured_image,
//           // Also try ACF fields if they exist
//           image: term.acf?.category_image || term.meta?.category_image || null
//         };
//       });
      
//       const hierarchy = buildHierarchy(enhancedData);
      
//       setCategories(hierarchy);
      
//       // Extract only level 2 categories (like "Machinery")
//       const extractedLevel2 = extractLevel2Categories(hierarchy);
//       setLevel2Categories(extractedLevel2);
      
//       debugLog('Full hierarchy:', hierarchy);
//       debugLog('Extracted Level 2 categories:', extractedLevel2);
//     } catch (err) {
//       console.error('Error fetching categories:', err);
//       setError(`Failed to load categories: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCategoryClick = (category) => {
//     // Navigate to products page with the selected category
//     const queryParams = new URLSearchParams({
//       taxonomy,
//       term: category.slug,
//       termName: category.name
//     });
//     navigate(`/products?${queryParams.toString()}`);
//   };

//   const handleTaxonomySwitch = (newTaxonomy) => {
//     setTaxonomy(newTaxonomy);
//     navigate(`/categories?taxonomy=${newTaxonomy}`);
//   };

//   // Get total subcategories count
//   const getTotalSubcategoriesCount = () => {
//     return level2Categories.reduce((total, cat) => total + (cat.childCount || 0), 0);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
//         {/* Breadcrumb */}
//         <nav className="flex items-center text-sm text-gray-600 mb-6">
//           <button
//             onClick={() => navigate('/')}
//             className="hover:text-accent-600 transition-colors flex items-center"
//           >
//             <Home className="w-4 h-4 mr-1" />
//             Home
//           </button>
//           <ChevronRight className="w-4 h-4 mx-2" />
//           <span className="text-gray-900 font-medium">Categories</span>
//         </nav>

//         {/* Page Header */}
//         <div className="mb-8">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-900 mb-2">
//                 All Categories
//               </h1>
//               <p className="text-gray-600">
//                 Browse {level2Categories.length} main categories with {getTotalSubcategoriesCount()} total subcategories {taxonomy === 'equipment-buy' ? 'for sale' : 'for rent'}
//               </p>
//             </div>
//           </div>

//           {/* Taxonomy Toggle */}
//           <div className="mt-6 flex flex-wrap gap-2">
//             <button
//               onClick={() => handleTaxonomySwitch('equipment-buy')}
//               className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                 taxonomy === 'equipment-buy'
//                   ? 'bg-accent-600 text-white'
//                   : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
//               }`}
//             >
//               Equipment for Sale
//             </button>
//             <button
//               onClick={() => handleTaxonomySwitch('equipment-rent')}
//               className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                 taxonomy === 'equipment-rent'
//                   ? 'bg-accent-600 text-white'
//                   : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
//               }`}
//             >
//               Equipment for Rent
//             </button>
//           </div>
//         </div>

//         {/* Controls Bar */}
//         <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            
//             {/* Search */}
//             <div className="relative flex-1 max-w-md">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search categories..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500"
//               />
//             </div>

//             {/* View Mode Toggle */}
//             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//               <button
//                 onClick={() => setViewMode('grid')}
//                 className={`p-2 rounded transition-colors ${
//                   viewMode === 'grid' 
//                     ? 'bg-white text-accent-600 shadow-sm' 
//                     : 'text-gray-600 hover:text-gray-900'
//                 }`}
//                 title="Grid view"
//               >
//                 <Grid className="w-4 h-4" />
//               </button>
//               <button
//                 onClick={() => setViewMode('list')}
//                 className={`p-2 rounded transition-colors ${
//                   viewMode === 'list' 
//                     ? 'bg-white text-accent-600 shadow-sm' 
//                     : 'text-gray-600 hover:text-gray-900'
//                 }`}
//                 title="List view"
//               >
//                 <List className="w-4 h-4" />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Error State */}
//         {error && (
//           <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
//             <p>{error}</p>
//             <button
//               onClick={fetchCategories}
//               className="mt-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//             >
//               Retry
//             </button>
//           </div>
//         )}

//         {/* Loading State */}
//         {loading && (
//           <div className="flex items-center justify-center py-12">
//             <Loader className="w-8 h-8 animate-spin text-black mr-3" />
//             <span className="text-gray-600">Loading categories...</span>
//           </div>
//         )}

//         {/* Categories Content */}
//         {!loading && !error && (
//           <>
//             {filteredCategories.length === 0 ? (
//               <div className="text-center py-12">
//                 <Package className="w-16 h-16 text-gray-400 mx-auto mb-4" />
//                 <h3 className="text-lg font-medium text-gray-900 mb-2">No categories found</h3>
//                 <p className="text-gray-500">
//                   {searchTerm ? 'Try adjusting your search terms.' : 'No categories available.'}
//                 </p>
//               </div>
//             ) : (
//               <div className={`${
//                 viewMode === 'grid' 
//                   ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'
//                   : 'space-y-4'
//               }`}>
//                 {filteredCategories.map((category) => (
//                   <Level2CategoryCard
//                     key={category.id}
//                     category={category}
//                     viewMode={viewMode}
//                     onClick={() => handleCategoryClick(category)}
//                   />
//                 ))}
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// Level 2 Category Card Component
// function Level2CategoryCard({ category, viewMode, onClick }) {
//   const [imageError, setImageError] = useState(false);
//   const [imageLoading, setImageLoading] = useState(true);
//   // Get the featured image URL, fallback to placeholder if not available
//   const getImageUrl = () => {
//     // Try multiple image sources in order of preference
    
//     // 1. Featured image with URL property
//     if (category.featured_image && category.featured_image.url) {
//       return category.featured_image.url;
//     }
    
//     // 2. Featured image as direct URL string
//     if (category.featured_image && typeof category.featured_image === 'string') {
//       return category.featured_image;
//     }
    
//     // 3. Image field (for custom fields)
//     if (category.image && typeof category.image === 'string') {
//       return category.image;
//     }
    
//     // 4. Image field as object with URL
//     if (category.image && category.image.url) {
//       return category.image.url;
//     }
    
//     // 5. ACF image field
//     if (category.acf && category.acf.category_image) {
//       if (typeof category.acf.category_image === 'string') {
//         return category.acf.category_image;
//       }
//       if (category.acf.category_image.url) {
//         return category.acf.category_image.url;
//       }
//     }
    
//     // 6. Meta image field
//     if (category.meta && category.meta.category_image) {
//       return category.meta.category_image;
//     }
    
//     // 7. Try WordPress media sizes if available
//     if (category.featured_image && category.featured_image.sizes) {
//       const sizes = category.featured_image.sizes;
//       if (sizes.medium && sizes.medium.source_url) {
//         return sizes.medium.source_url;
//       }
//       if (sizes.thumbnail && sizes.thumbnail.source_url) {
//         return sizes.thumbnail.source_url;
//       }
//       if (sizes.full && sizes.full.source_url) {
//         return sizes.full.source_url;
//       }
//     }
    
//     // Debug: Log what's available for this category
//     debugLog('No image found for category:', category.name, {
//       featured_image: category.featured_image,
//       image: category.image,
//       acf: category.acf,
//       meta: category.meta
//     });
    
//     // Fallback placeholder if no featured image
//     return `https://via.placeholder.com/300x200/f3f4f6/6b7280?text=${encodeURIComponent(category.name)}`;
//   };

//   // Handle image load error
//   const handleImageError = () => {
//     setImageError(true);
//     setImageLoading(false);
//   };

//   // Handle image load success
//   const handleImageLoad = () => {
//     setImageLoading(false);
//   };

//   const imageUrl = getImageUrl();
//   const isPlaceholder = imageUrl.includes('via.placeholder.com');

//   if (viewMode === 'list') {
//     return (
//       <div 
//         className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-200 cursor-pointer"
//         onClick={onClick}
//       >
//         <div className="flex items-center p-4">
//           <div className="w-16 h-16 bg-gray-200 rounded-lg flex-shrink-0 mr-4 relative overflow-hidden">
//             {!isPlaceholder && imageLoading && (
//               <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
//                 <Loader className="w-4 h-4 animate-spin text-gray-400" />
//               </div>
//             )}
//             <img
//               src={imageUrl}
//               alt={category.name}
//               className={`w-full h-full object-cover rounded-lg transition-opacity ${
//                 imageLoading ? 'opacity-0' : 'opacity-100'
//               }`}
//               onError={handleImageError}
//               onLoad={handleImageLoad}
//               loading="lazy"
//             />
//           </div>
          
//           <div className="flex-1">
//             <h3 className="text-lg font-semibold text-gray-900">
//               {category.name}
//             </h3>
//           </div>
          
//           <ChevronRight className="w-5 h-5 text-gray-400" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div 
//       className="bg-white rounded-lg shadow-sm hover:shadow-lg transition-all border border-gray-200 overflow-hidden group cursor-pointer"
//       onClick={onClick}
//     >
//       {/* Category Image */}
//       <div className="aspect-video bg-gray-200 relative overflow-hidden">
//         {!isPlaceholder && imageLoading && (
//           <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
//             <Loader className="w-8 h-8 animate-spin text-gray-400" />
//           </div>
//         )}
//         <img
//           src={imageUrl}
//           alt={category.name}
//           className={`w-full h-full object-cover group-hover:scale-105 transition-all duration-300 ${
//             imageLoading ? 'opacity-0' : 'opacity-100'
//           }`}
//           onError={handleImageError}
//           onLoad={handleImageLoad}
//           loading="lazy"
//         />
//       </div>

//       {/* Category Content */}
//       <div className="p-4">
//         <h3 className="text-lg font-semibold text-gray-900 group-hover:text-black transition-colors mb-1">
//           {category.name}
//         </h3>
//       </div>
//     </div>
//   );
// }



// New Code Start Here

export default function CategoryListing() {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-neutral-500 to-neutral-400 text-black py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="flex items-center justify-center mb-4">
                <h1 className="text-4xl md:text-5xl font-display font-bold">
                  All Categories
                </h1>
              </div>
              <p className="text-xl opacity-90 max-w-2xl mx-auto">
                Find the perfect Machinery for your needs
              </p>
            </div>
          </div>
        </section>
    {/* Browse by Category */}
          <section className="py-16 bg-neutral-50">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center">
                    <div className="mb-12">
                      <div className="flex items-center space-x-4 mb-2">
                      <div className="w-12 h-0.5 bg-gradient-to-r from-[#FFD200] to-[#F7971E] rounded-full"></div>
                      <span className="text-base font-bold tracking-wider gradient-text uppercase">
                        Our Inventory
                      </span>
                    </div>
                      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-neutral-900 mb-4">
                        Browse by Category
                      </h2>
                      <p className="text-lg text-neutral-600">
                        Find the perfect equipment for your needs
                      </p>
                    </div>
          
                    <div className="hidden sm:block">
                      <Link to="/products?taxonomy=equipment-buy" className="viewAll font-semibold hover:underline">Browse Inventory</Link>
                    </div>
                    <style jsx>{`
                    .viewAll {background: linear-gradient(159.21deg, #EEC712 11.19%, #CA7710 101.23%);
              background-clip: text;
              color: transparent;
              -webkit-text-fill-color: transparent;
                    }
          
                    .viewAll::after {
              content: '›';
              font-size: 18px;
              transition: transform 0.2s ease;
              margin-left:5px;
          }
                    
                    `}</style>
                    </div>
           
                    <div className={`browse-grid-wrapper ${expanded ? "expanded" : ""}`}>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                      {/* Card 1 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=skid-steer&termName=Skid%20Steer"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/skid_steer.webp"
                            alt="Skid Steer Loaders"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Skid Steer
                        </h3>
                      </Link>
           
                      {/* Card 2 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=mini-excavators&termName=Mini%20Excavators"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/mini_excavator.webp"
                            alt="Mini Excavator"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Mini Excavators
                        </h3>
                      </Link>
           
                      {/* Card 3 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=excavators&termName=Excavators"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/excavator_img.webp"
                            alt="Excavator"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Excavators
                        </h3>
                      </Link>
          
                      {/* Card 4 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=backhoe-loaders&termName=Backhoe Loaders"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/backhoe_loader.webp"
                            alt="Backhoe Loaders"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Backhoe Loaders
                        </h3>
                      </Link>
          
                      {/* Card 5 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=air-compressor&termName=Air%20Compressor"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/airCompressor.webp"
                            alt="Air Compressor"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Air Compressor
                        </h3>
                      </Link>
          
                      {/* Card 6 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=dozer&termName=Dozer"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/dozer_img.webp"
                            alt="Dozer"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Dozer
                        </h3>
                      </Link>
          
                      {/* Card 7 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=tower-lights&termName=Tower%20Lights"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/towerlight_1.webp"
                            alt="Compactors"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Tower Lights
                        </h3>
                      </Link>
          
                      {/* Card 8 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=loaders&termName=Loaders"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/loader_img.webp"
                            alt="Loader"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Loader
                        </h3>
                      </Link>
           
                      {/* Card 9 */}
                      {/* <Link
                        to="/products?taxonomy=equipment-buy&term=pavers&termName=Pavers"
                        className="bg-white browse-card p-6 group aspect-square flex flex-col"
                      >
                        <div className="sm:flex-1 flex items-center justify-center mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/paver_img.webp"
                            alt="Paver"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-lg font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Paver
                        </h3>
                      </Link> */}
           
                      {/* Card 10 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=forklifts&termName=Forklifts"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/forklift_img.webp"
                            alt="forklift"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Forklift
                        </h3>
                      </Link>
          
                      {/* Card 11 */}
                      <Link
                        to="/products?taxonomy=equipment-buy&term=telehandler&termName=Tele%20Handler"
                        className="bg-white browse-card p-4 sm:p-2 group aspect-square flex flex-col w-[100%] sm:w-full"
                      >
                        <div className="flex-1 flex items-center justify-center mb-3 sm:mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/boom_loader.webp"
                            alt="Tele Handler"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <div className="flex-shrink-0">
                          <h3 className="text-sm sm:text-xl font-semibold text-center text-neutral-900 mb-1">
                            Tele Handler
                          </h3>
                          <p className="text-center font-medium text-xs sm:text-sm text-[#9f9f9f]">(Boom Loader)</p>
                        </div>
                      </Link>
           
                      {/* Card 12 */}
                      {/* <Link
                        to="/products?taxonomy=equipment-buy&term=electric-forklifts&termName=Electric Forklifts"
                        className="bg-white browse-card p-6 group aspect-square flex flex-col"
                      >
                        <div className="sm:flex-1 flex items-center justify-center mb-4 transition-transform overflow-hidden">
                          <img
                            src="/images/homePage/arial_work.webp"
                            alt="Arial Work Platform"
                            className="max-w-full max-h-full filter transition duration-300 object-contain"
                          />
                        </div>
                        <h3 className="text-lg font-semibold text-center text-neutral-900 mb-2 flex-shrink-0">
                          Arial Work Platform
                        </h3>
                      </Link> */}
          
          
                      
                    </div>
                    <div className="flex items-center justify-center mt-8 sm:hidden">
                      <button onClick={() => navigate("/products?taxonomy=equipment-buy")} className="view-more-btn flex items-center justify-center"><Search className="w-4 h-4 mr-1"/>Browse Inventory</button>
                    </div>
          </div>
           
          {/* Button OUTSIDE the wrapper */}
          {!expanded && (
            <div className="flex justify-between items-center gap-3">
            <button
              className="view-more-btn gradientBorder block w-full sm:hidden lg:hidden xl:hidden"
              onClick={() => setExpanded(true)}
            >
              View More
            </button>
            <button onClick={() => navigate("/products?taxonomy=equipment-buy")} className="view-more-btn w-full flex items-center justify-center sm:hidden"><Search className="w-4 h-4 mr-1"/>Browse Inventory</button>
            <style jsx>{`
            .view-more-btn.gradientBorder{
              border:solid 3px #FFD200;
              transition: all 0.3s ease;
            }
          
            .view-more-btn.gradientBorder:hover{
              background:linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%)!important;
            }
          
            `}</style>
            </div>
            
          )}
           
           
                  </div>
                  
                  <style>
                    {`
                    .browse-card{
              border: 2px solid #eaeaea;
              border-radius: 8px;
          }
          
          .browse-card img{
          mix-blend-mode: multiply;
          }
          .browse-card:hover{
              border-width: 2px;
              border-color: #f90;
              background-color: #fffaeb;
              box-shadow: 0 4px 12px 0 rgb(0 0 0 / 10%);
              transition: all .3s;
          }
           
          .browse-card:hover img{
                  transform: scale(1.05);
          }
                    `}
                  </style>
                </section>
  </div>
  );
}